import { faLinkedin } from "@fortawesome/free-brands-svg-icons";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Link from "next/link";

const clientData = [
    {
        imageSrc: 'img/about-us/jpg/logo-8.jpg',
        altText: 'company1'
    },

    {
        imageSrc: 'img/about-us/jpg/logo-9.jpg',
        altText: 'company1'
    },
    {
        imageSrc: 'img/about-us/jpg/logo-10.jpg',
        altText: 'company1'
    },
    {
        imageSrc: 'img/about-us/jpg/logo-11.jpg',
        altText: 'company1'
    },
    {
        imageSrc: 'img/about-us/jpg/logo-12.jpg',
        altText: 'company1'
    },
    {
        imageSrc: 'img/about-us/jpg/logo-13.jpg',
        altText: 'company1'
    },
    {
        imageSrc: 'img/about-us/jpg/logo-14.jpg',
        altText: 'company1'
    },
    {
        imageSrc: 'img/about-us/jpg/logo-15.jpg',
        altText: 'company1'
    },
    {
        imageSrc: 'img/about-us/jpg/logo-16.jpg',
        altText: 'company1'
    },
    {
        imageSrc: 'img/about-us/jpg/logo-17.jpg',
        altText: 'company1'
    },
    {
        imageSrc: 'img/about-us/jpg/logo-18.jpg',
        altText: 'company1'
    },
    {
        imageSrc: 'img/about-us/jpg/logo-19.jpg',
        altText: 'company1'
    },
    {
        imageSrc: 'img/about-us/jpg/logo-20.jpg',
        altText: 'company1'
    },
    {
        imageSrc: 'img/about-us/jpg/logo-21.jpg',
        altText: 'company1'
    },
    {
        imageSrc: 'img/about-us/jpg/logo-22.jpg',
        altText: 'company1'
    },
    {
        imageSrc: 'img/about-us/jpg/logo-23.jpg',
        altText: 'company1'
    },
    {
        imageSrc: 'img/about-us/jpg/logo-24.jpg',
        altText: 'company1'
    },
    {
        imageSrc: 'img/about-us/jpg/logo-1.jpg',
        altText: 'company1'
    },
    {
        imageSrc: 'img/about-us/jpg/logo-2.jpg',
        altText: 'company1'

    },
    {
        imageSrc: 'img/about-us/jpg/logo-3.jpg',
        altText: 'company1'
    },
    {
        imageSrc: 'img/about-us/jpg/logo-4.jpg',
        altText: 'company1'
    },
    {
        imageSrc: 'img/about-us/jpg/logo-5.jpg',
        altText: 'company1'
    },
    {
        imageSrc: 'img/about-us/jpg/logo-6.jpg',
        altText: 'company1'
    },
]

const feedbackData = [
    {
        review: ' This is to express my gratitude and satisfaction on the report "Telomerase Inhibitors - Pipeline Insight" from Delvelnsight, despite my own knowledge and the work of my assistants, your report was of utmost importance to guide us to the newest and hottest trends on the topic. In recognition to that, we acknowledge it in the paper: "The authors want to express their gratitude to DelveInsight for helping us to obtain important and significant information for this work.',
        description: '--Full Professor. Former Chancellor. Quilmes National University. Former Director of the National Cancer Institute of Argentina'
    },
    {
        review: 'Thanks. Your assessment makes complete sense and fits in the puzzle. Saved a lot of my effort.',
        description: '-- Lead, Business Strategy, A Korean Pharma'
    },
    {
        review: "I must say this is by far the best collaboration I've received from a consulting agency. Just want to highlight that your commentary on top of few of the events was extremely valuable. I would like to see more of it.",
        description: '-- CMO, EU Based Small Biotech'
    },
    {
        review: "Thanks for the speed, this is really exceeding expectations.",
        description: "-- Director, Commercial Operations, A US Biotec"
    },
    {
        review: "Guys, congress was a success. Thanks to your event prioritization, I could save a lot of my time to get a better view of San Diego. Cheers!",
        description: "-- Director, Medical Affairs and Strategy, A US Blue Chip Pharma. "
    },
    {
        review: " Thanks for the support. Your analytical skills are much of help. They have a passion for results and a commitment to complete transparency.",
        description: "-- CI Lead, A EU Pharma Company"
    },
    {
        review: ' This is to express my gratitude and satisfaction on the report "Telomerase Inhibitors - Pipeline Insight" from Delvelnsight, despite my own knowledge and the work of my assistants, your report was of utmost importance to guide us to the newest and hottest trends on the topic. In recognition to that, we acknowledge it in the paper: "The authors want to express their gratitude to DelveInsight for helping us to obtain important and significant information for this work.',
        description: '-- Full Professor. Former Chancellor. Quilmes National University. Former Director of the National Cancer Institute of Argentina'
    }
]

const whatWeDoData = {
    title: 'At a Glance',
    firstTitle: 'About DelveInsight',
    firstDescription: <>We are a business consulting firm with deep industry expertise in the healthcare domain with a core focus on pharma and biotech industries. We consistently help our clients in taking sound decisions facilitating better business performances and achieving incredible growth.  <br />
        Since its inception, DelveInsight has played a pioneering role in providing state of the art services to its clients and prompting informed speculations of the probable prevailing market trends.       </>,
    second: {
        title: "What we do",
        description: "We specialize in providing both detailed as well as customized market research analysis to help our clients achieve their business goals and uncover new market opportunities.",
        imageSrc: "/img/about-us/png/what-we-do-2.png"

    },
    third: {
        title: "How We Do",
        description: "We employ a rich workforce with deep industry knowledge, domain expertise and internal database that help us provide state of the art services to our clients.",
        imageSrc: "/img/about-us/png/how-we-do-2.png"
    }
}

const serviceData = [
    {
        title: 'Market Research',
        imageSrc: 'img/about-us/png/market-research-2.png',
        link: '/market-research'
    },
    {
        title: 'Business Consulting',
        imageSrc: 'img/about-us/png/business-consulting-2.png',
        link: '/consulting'
    },
    {
        title: 'Competitive Intelligence',
        imageSrc: 'img/about-us/png/competitive-intelligence-2.png',
        link: '/consulting/competitive-intelligence-services'
    },
    {
        title: 'Pharmdelve',
        imageSrc: 'img/about-us/png/pharmdelve-2.png',
        link: '/pharmdelve'
    }
];

const messageSectionData = {
    title: 'Message From CEO',
    imageSrc: '/img/about-us/jpg/vishal-sir-image.png',
    bg_imageSrc: '/img/about-us/jpg/banner/map-dotted.png',

    body: 
    <>
        <p className="text-base">DelveInsight has served more than 1000 clients across 20+ geographies in a span of more than 10 years and is striving to provide more.</p>
        <p className="text-base">Achieving this acme has been possible due to our clear focus on getting the best talent in the company. We are a client-focused market research and consulting firm, and our unwavering focus and commitment towards excellence lead us to proffer best-suited solutions to our clients.</p>
        <p className="text-base">At DelveInsight, we value the business needs and goals of our clients. Understanding our client and investing in the relationship has helped us deliver results as per their requirements.</p>
        <p className="text-base">I personally stand behind each of our engagements and ensure the best possible quality in every project, DelveInsight undertakes. We are firmly committed to our client success- as we understand that our success will naturally follow.  </p>
    </>,
    footer: <>
        <div className="grid grid-cols-12">
            <div className="col-span-12">
                <p className='p-0 m-0 font-semibold text-left'>Dr. Vishal Agrawal</p>
                <p className='p-0 m-0 font-semibold text-left'>Chief Executive Officer (CEO)</p>
                <div className='flex grid-cols-2'>
                    <Link href="https://www.linkedin.com/in/dr-vishal-agrawal-90841b6" className='rounded-full text-[#1b5df3]  px-3 py-1.5 m-1 text-lg border-solid border-gray-700 bg-slate-100 dark:bg-gray-700 hover:bg-[#0073b1] hover:dark:bg-[#0073b1] hover:text-white'>
                        <FontAwesomeIcon className='p-0 m-0 text-md' icon={faLinkedin} />
                    </Link>
                    <Link href="mailto:dr.vishal123@gmail.com" className='rounded-full text-[#1b5df3]  px-3 py-1.5 m-1 text-lg border-solid border-gray-700 bg-slate-100 dark:bg-gray-700 hover:bg-[#ff4646] hover:dark:bg-[#ff4646] hover:text-white'>
                        <FontAwesomeIcon className='p-0 m-0 text-md' icon={faEnvelope} />
                    </Link>
                </div>
            </div>
        </div>
    </>,
    linkedin: '',
    gmail: ''
}

const ourValuesData = {
    title: 'Our Values',
    background: '/img/about-us/jpg/banner/our_values.jpg',
    theme: 'light',
    items: [
        {
            title: 'Passion',
            description: 'Our clients are the soul of our business. We are committed to providing them great results by being active listeners and helping them in their concerns by a proactive approach.',
            icon: 'img/about-us/svg/passion.svg'
        },
        {
            title: 'Integrity',
            description: 'DelveInsight has been able to serve its clients successfully due to the one most important principle the employees most religiously follow, and that is truthfulness.',
            icon: 'img/about-us/svg/Integrity.svg'
        },
        {
            title: 'Team Work',
            description: 'At DelveInsight, we religiously integrate solutions and strategies that are executed by the concerned team for effective, and productive yield.',
            icon: 'img/about-us/svg/team_work.svg'
        },
        {
            title: 'Excellence',
            description: 'At DelveInsight, Excellence is everything. We are committed to delivering the best results in every project we undertake with excellence.',
            icon: 'img/about-us/svg/excellence.svg'
        }
    ]
}

const OurAdvisorsData = {
    background: '/img/about-us/jpg/banner/waves.jpg',
    title: 'Our Advisors',
    items: [
        {
            name: 'Dr. B.K. Agrawal',
            imageSrc: 'img/about-us/jpg/founder/dr_b_k_agrawal.jpg',
            designation: 'Managing Partner',
            linkedin: 'https://www.linkedin.com/in/dr-b-k-agrawal-22a67097',
            email: 'mailto:bagrawal@delveinsight.com',
            content:"Dr. B.K Agrawal is a medical graduate and has done his Masters in General Surgery. He has towering experience in Healthcare Industry which includes Hospitals and Pharma companies. He served as Medical Consultant with a state government in India for close to 25 years. He has also served as a Business consultant for multiple hospitals and Pharma companies since 1996. He possess skills in organizing, interpreting and communicating market information/data to facilitate decision making process. He is actively involved in formulating long term/short term strategic plans to enhance operations."
        },
        {
            name: 'Ms. Preeti',
            imageSrc: 'img/about-us/jpg/founder/preeti_agrawal.jpg',
            designation: 'Chief Operating Officer (COO)',
            linkedin: 'https://www.linkedin.com/in/preeti-agrawal-7721412',
            email: 'mailto:pagrawal@delveinsight.com',
            content:"Preeti is a seasoned market research consultant with close to 20 years of experience, bringing a strong blend of scientific knowledge and technical acumen to her work. A science graduate with a master's in computer applications, she further honed her strategic and managerial skills by completing an executive MBA from the prestigious IIM Rohtak. Throughout her career, she has been an integral part of renowned firms like Toluna (Greenfield), Kadence, and Internationallinx. She has traveled extensively, engaging directly with clients to address their needs and provide tailored actionable solutions. Her expertise is in client relations based on customer satisfaction and loyalty resulting in high-impact results."
        },
        {
            name: 'Mr. Gunjan Aggarwal',
            imageSrc: 'img/about-us/jpg/founder/gunjan_aggarwal.jpg',
            designation: 'Advisory Board',
            linkedin: 'https://www.linkedin.com/in/gunjaniimc',
            email: 'mailto:gunjaniimcal@gmail.com',
            content:"With over 15 years of experience across various industries and domains, he is a versatile and adaptable Operations & Strategy leader, passionate about solving complex problems and delivering value to customers. Currently, he serves as the AVP Operations (Head of Supply and Delivery) at Expand My Business, a well-funded platform that aggregates IT services for businesses across Web 1.0, Web 2.0, and digital marketing. Always eager to learn new skills and explore new opportunities, he has a strong background in operations, strategy, analytics, edtech, marketplaces, research, consulting, and product development. Gunjan is an alumnus of IIM Calcutta & Copenhagen Business School."
        },
        {
            name: 'Mr. Manish Mayank',
            imageSrc: 'img/about-us/jpg/founder/manish_mayank.jpg',
            designation: 'Advisory Board',
            linkedin: 'https://www.linkedin.com/in/manishmayank',
            email: 'mailto:withmanish@gmail.com',
            content:"Manish Mayank earned his MBA from Duke University, USA with a concentration in Investment Finance and Strategy, and completed his Bachelor's and Master's from the Indian Institute of Technology, Kharagpur. He has over 15 years of experience across the financial services, management consulting, and growth technology industries. His experience includes helping clients formulate growth strategies, perform market assessments, competitive benchmarking, and support the firm's thought leadership. Currently, he is a senior finance professional at Microsoft and leads product performance, go-to-market, and portfolio growth strategy evolution."
        },
        {
            name: 'Mr. Piyush Pranay',
            imageSrc: 'img/about-us/jpg/founder/piyush-pranay.jpg',
            designation: 'Advisory Board',
            linkedin: 'https://www.linkedin.com/in/piyushpranay',
            email: 'mailto:ppranay@linkedin.com',
            content:"Piyush is a senior product manager at Amazon, leading the seller fees experience, for their multi-billion dollar FBA (Fulfilled by Amazon) fees. Previously he was part of LinkedIn's leadership team in India. He helped launch several key products such as LinkedIn Lite, enabling India to become one of the fastest growing consumer markets for LinkedIn globally. Piyush has also advised several blue chip companies across multiple sectors such as pharma, healthcare, manufacturing, logistics, financial services etc., during his stint as a Senior Consultant at Bain & Company. He is an alumnus of IIM Ahmedabad and IIT Kharagpur."
        },
    ]
}

const OurSpecialist = [
    {
        name: 'Shikha Sharma',
        imageSrc: '/img/about-us/png/shikha-delveinsight.png',
        designation: 'Associate Director',
        description: 'With over 15 years of experience in business development within market research, business consulting, and contract manufacturing in the healthcare sector, Shikha excels at establishing and nurturing strategic relationships and partnerships with clients.',
        linkedin: 'https://www.linkedin.com/in/shikha-sharma-8b68b615/'
    },
    // {
    //     name: 'Chery Anne Abranches',
    //     imageSrc: '/img/about-us/jpg/Cheryl.png',
    //     designation: 'Functional Head, Forecasting',
    //     description: 'With an experience of more than 10 years in providing strategic decision support to top global pharmaceuticals. She holds exceptional expertise in project management and business development, having worked with cross-cultural teams.',
    //     linkedin: 'https://in.linkedin.com/in/cheryl-anne-abranches-6762186/'
    // },
    {
        name: 'Rajesh Sharma',
        imageSrc: '/img/about-us/png/rajesh-delveinsight.png',
        designation: 'Associate Director',
        description: 'With over 15 years of experience in the rare disease and oncology markets, Rajesh is skilled in analyzing market dynamics and forecasting future trends, providing valuable insights to support business growth and client success.',
        linkedin: 'https://www.linkedin.com/in/rajesh-sharma-9333b923/'
    },
];

const accordionList = [
    {
        title:'Understanding Client Requirements',
        description:'Client understanding is essential for every B2C and B2B company in each domain. We make sure to identify the problems our client is facing and help them give shape to their ideas and achieve targets.'
    },
    {
        title:'Brainstorming And In-Depth Research',
        description:'To grow in the market, it is important to have a mind-map prior to making any business move. Our analysts analyse the audience and the market of the client and present new approaches and a wealth of insights to our clients.'
    },
    {
        title:'100% Post-Sales Support',
        description:'We value our clients and believe in maintaining long-term relationships with them. DelveInsight is proactive in reaching out to its client even after the sales and asks them to share their experience for self-improvement.'
    }
];
const OurUSP = {
    title: 'Our USPs',
    usp_data: [
        {
            title: 'Deep-domain expertise',
            description: " We have a vast repository of over 7000 research reports covering 27+ therapeutic areas. ",
            icon: 'img/about-us/svg/deep_domain_expertise.svg'
        },

        {
            title: 'Accurate Data',
            description: "We deliver right market intelligence to provide our clients with powerful strategies for their business decisions.",
            icon: 'img/about-us/svg/accurate_data.svg'
        },
        {
            title: 'Analytical Approach',
            description: "Our Data is processed through advanced analytics to yield fast, accurate and deep insights. at granular level facilitating value addition.",
            icon: 'img/about-us/svg/analytical_approach.svg'
        },
        {
            title: 'Customized Solutions',
            description: "We offer personalized, integrated, and handcrafted market solutions to cater to the needs of the clients for maximized benefits.",
            icon: 'img/about-us/svg/customized_solutions.svg'
        }
    ],
    title_1:"Our Work Philosphy",
    items:[
        {
            title:'Understanding Client Requirements',
            description:'Client understanding is essential for every B2C and B2B company in each domain. We make sure to identify the problems our client is facing and help them give shape to their ideas and achieve targets.'
        },
        {
            title:'Brainstorming And In-Depth Research',
            description:'To grow in the market, it is important to have a mind-map prior to making any business move. Our analysts analyse the audience and the market of the client and present new approaches and a wealth of insights to our clients.'
        },
        {
            title:'100% Post-Sales Support',
            description:'We value our clients and believe in maintaining long-term relationships with them. DelveInsight is proactive in reaching out to its client even after the sales and asks them to share their experience for self-improvement.'
        }
    ]
}

export {
    clientData,
    whatWeDoData,
    serviceData,
    messageSectionData,
    ourValuesData,
    OurAdvisorsData,
    feedbackData,
    OurSpecialist,
    OurUSP,
    accordionList
}
